import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import { useLanguage } from '../contexts/LanguageContext';
import useMediaQuery from '../hooks/useMediaQuery';

const WhatsAppButton = ({ style }) => {
    const { t } = useLanguage();
    const isMobile = useMediaQuery('(max-width: 768px)');

    const message = t('hero.shareMessage');
    const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(message)}`;

    const buttonStyle = {
        backgroundColor: '#25D366',
        color: 'white',
        border: 'none',
        borderRadius: '50px',
        padding: isMobile ? '0.4rem 0.8rem' : '0.5rem 1rem',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        textDecoration: 'none',
        fontWeight: 'bold',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        fontSize: isMobile ? '0.9rem' : '1rem',
        marginLeft: '1rem', // Default spacing
        ...style // Allow overriding/adding styles
    };

    return (
        <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" style={buttonStyle}>
            <FaWhatsapp style={{ fontSize: '1.2rem', marginRight: '0.5rem' }} />
            {t('header.share')}
        </a>
    );
};

export default WhatsAppButton;
